import React from "react";
import { T } from "../app/tokens.js";

export function HeaderAreaLabel({ children, testId, title }) {
  const match = typeof children === "string" ? children.match(/^(.*)( \(\+\d+ expired\))$/) : null;
  return (
    <span
      data-testid={testId}
      title={title ?? children}
      style={{
        fontSize: T.fsMd,
        color: T.light,
        fontWeight: T.fwRegular,
        display: "inline-flex",
        ...(match ? { flexBasis: "100%", flexShrink: 0 } : {}),
        maxWidth: 230,
        minWidth: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {match ? <><span style={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" }}>{match[1]}</span>
        <span style={{ flexShrink: 0, marginLeft: 4, color: T.light, opacity: 0.7, fontWeight: T.fwRegular }}>{match[2]}</span></> : children}
    </span>
  );
}